<template>
  <MobileSimpleModalContainer>
    <v-flex :class="$style.modalAdvantages">
      <p>No Gimmicks, No Frills, No Nonsense</p>
      <h6>Grassfed. Natural. Goodness.</h6>
    </v-flex>
    <v-flex>
      <h4 :class="$style.modalTitle">BURGER BOSS BASICS</h4>
    </v-flex>
    <v-flex :class="$style.modalIconsInfo">
      <div>
        <img src="@/assets/img/glutenfree@2x.jpg"
             alt="Gluten Free">
        <span>Gluten Free</span>
      </div>

      <div>
        <img src="@/assets/img/vegan@2x.jpg"
             alt="Vegan">
        <span>Vegan</span>
      </div>
    </v-flex>
  </MobileSimpleModalContainer>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import Logo from '@/components/Logo';
import MobileSimpleModalContainer from '@/apps/mobile/components/MobileSimpleModalContainer';


@Component({
  name:       'HelpModal',
  components: {
    MobileSimpleModalContainer,
    Logo,
  },
  props: {
    closeHandler: () => {},
  },
})
export default class HelpModal extends Vue {
  show = false;

  close() {
    this.$emit('close');
  }
}
</script>

<style lang="scss" module>
  @import "@/style/variables.scss";

  .modalAdvantages {
    text-align: center;
    padding-bottom: 16px;
    position: relative;
    margin-bottom: 18px;
    p {
      font-family: 'LP Bambus', sans-serif;
      font-size: 16px;
      font-weight: 400;
      color: $black;
    }
    h6 {
      font-size: 14px;
      color: $green2;
      text-transform: uppercase;
    }
    &::after {
      content: '';
      position: absolute;
      width: 200px;
      height: 2px;
      background-color: $title-black;
      bottom: 0;
      left: calc(50% - 100px);
    }
  }
  .modalTitle {
    font-family: 'Gotham', sans-serif;
    color: $black-slightly-transparent;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    margin-bottom: 17px;
  }
  .modalIconsInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 30px;
    div {
      display: flex;
      align-items: center;
    }
    img {
      width: 17px;
      height: 17px;
      margin-right: 8px;
    }
    span {
      font-family: 'Gotham', sans-serif;
      color: $black;
      font-size: 12px;
      line-height: 14px;
      font-style: italic;
    }
  }

  @media screen and (width: 1080px) {
    .modalAdvantages {
      p {
        font-size: 45px;
        line-height: 22px;
      }
      h6 {
        font-size: 34px;
        line-height: 66px;
      }
      &::after {
        width: 305px;
        height: 6px;
        left: calc(50% - 152px);
      }
    }
    .modalTitle {
      font-size: 34px;
      line-height: 66px;
      font-weight: 900;
    }
    .modalIconsInfo {
      padding: 0 40px;
      img {
        width: 38px;
        height: 38px;
        margin-right: 19px;
      }
      span {
        font-size: 34px;
        line-height: 48px;
        font-style: normal;
        font-weight: 300;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HelpModal.vue